import React, { ReactNode } from "react";

import "./top-toolbar.css";

export const TopToolbar = ({ left, right }: { left: ReactNode; right: ReactNode }) => (
	<div className="top-toolbar">
		<div className="top-toolbar__left">{left}</div>

		<div className="top-toolbar__right">{right}</div>
	</div>
);

TopToolbar.displayName = "TopToolbar";
